import './src/vaadin-grid-column-group.js';

export * from './src/vaadin-grid-column-group.js';
